const videoSectionContainer = {
  gap: '0.625rem',
  alignSelf: 'stretch',
  padding: { xs: '1.5rem 1rem', ipad: '1.5rem 2rem' },
  height: '100%',
};

const videoContentStack = (theme) => ({
  flexDirection: { xs: 'column', md: 'row' },
  height: '100%',
  width: '100%',
  maxWidth: '80rem',
  borderRadius: '1.25rem',
  backgroundColor: theme.palette.contrast.A600,
  backgroundImage: `
    linear-gradient(#4A5680 1px, transparent 1px),
    linear-gradient(90deg, #4A5680 1px, transparent 1px)
  `,
  backgroundSize: '25px 25px',
  backgroundPosition: 'center',
  padding: '2rem',
  gap: '3rem',
});

const titleTypography = {
  color: 'white',
  fontSize: { xs: '1.5rem', phone: '2.25rem', md: '2.75rem' },
};

const descriptionTypography = {
  lineHeight: '120%',
  color: 'white',
  fontWeight: 500,
  fontSize: { xs: '1rem', md: '1.125rem' },
};

const videoImageContainer = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  alignSelf: 'center',
  maxWidth: '30rem',
  width: { xs: '100%', lg: '70%' },
  height: '100%',
  cursor: 'pointer',
  borderRadius: '0.75rem',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.02)',
  },
};

const videoImageStyles = {
  objectFit: 'contain',
  width: '100%',
  borderRadius: '0.75rem',
};

export {
  videoSectionContainer,
  videoContentStack,
  titleTypography,
  descriptionTypography,
  videoImageContainer,
  videoImageStyles,
};
